


























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { ActivationModel, IndividualModel } from '@/app/shared/models';
import DialogIndividual from '@/app/shared/components/dialogs/individual.vue';
@Component({ components: { DialogIndividual } })
export default class CardIndividualComponent extends Vue {
  @Prop(Object) readonly data!: IndividualModel;
  @Prop(Object) readonly dataSuport!: ActivationModel;

  private dialog = false;
  private loading = false;

  private get refs() {
    return refsService;
  }
  private get email() {
    const email = this.refs.util.findEmail(this.data.Contacts);
    return email && !this.refs._.isEmpty(email) ? email.Value : undefined;
  }
  private get document() {
    return this.data.Document
      ? this.refs.util.createMask(
          this.data.Document,
          this.data.DocumentType == 'CPF'
            ? '###.###.###-##'
            : '##-###-###/####-##'
        )
      : undefined;
  }

  private openDialogIndividual() {
    this.refs.modules.policy.SET_INDIVIDUAL(this.data);
    this.refs.modules.policy.SET_ACTIVATION(this.dataSuport);
    this.dialog = true;
  }
  private async closeDialogIndividual(
    individual: IndividualModel,
    newAddress: boolean,
    newEmail: boolean,
    newPhone: boolean
  ) {
    this.refs.modules.policy
      .updateIndividual({
        policyId: this.refs.modules.policy.policy.Id,
        activationId: this.dataSuport.Id,
        individualId: individual.Id,
        individual,
        newAddress,
        newEmail,
        newPhone,
      })
      .then(() => {
        this.$toast(this.$t('toasts.update_individual_successfully'));
        this.refs.services.policy
          .getActivationById(
            this.refs.modules.policy.policy.Id,
            this.dataSuport.Id
          )
          .then((res) => {
            this.$emit('update', res);
            this.dialog = false;
          });
      })
      .catch((err) => {
        this.refs.util.showErrors(err);
        this.$toast.error('ERROR ? ', err);
        this.$toast.error(this.$t('toasts.update_individual_error'));
      });
  }

  private async deleteIndividual() {
    this.loading = true;
    this.refs.services.policy
      .deleteIndividual(
        this.refs.modules.policy.policy.Id,
        this.dataSuport.Id,
        this.data.Id
      )
      .then(() => {
        this.$toast(this.$t('toasts.delete_individual_successfully'));
        this.refs.services.policy
          .getActivationById(
            this.refs.modules.policy.policy.Id,
            this.dataSuport.Id
          )
          .then((res) => this.$emit('update', res));
      })
      .catch((err) => {
        this.$toast.error('ERROR ? ', err);
        this.$toast.error(this.$t('toasts.delete_individual_error'));
      })
      .finally(() => (this.loading = false));
  }
}
